<mat-drawer-container appSidebarToggle class="admin-container material-admin-colors" autosize>
  <mat-drawer #drawer class="admin-sidenav" mode="side" [opened]="true">
    <header [title]="'Admin'"></header>

    <mat-nav-list>
      <mat-list-item [class.disabled]="isAdminTabDisabled" (click)="onMenuClick()" class="users"
        [routerLink]="['/Admin/UsersTable']" [routerLinkActive]="'nav-active'"
        [routerLinkActiveOptions]="{ exact: true }">
        <div class="admin-menu-image"></div>
        View all users
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item *ngIf="isAllowedByLicense() && adminRole | isInRole" [class.disabled]="isAdminTabDisabled"
        (click)="onMenuClick()" class="launchers" [routerLink]="['/Admin/Launcher']" [routerLinkActive]="'nav-active'"
        [routerLinkActiveOptions]="{ exact: true }">
        <div class="admin-menu-image"></div>
        Manage launchers
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item [class.disabled]="isAdminTabDisabled" (click)="onMenuClick()" (click)="onMenuClick()"
        class="system" [routerLink]="['/Admin/Info']" [routerLinkActive]="'nav-active'"
        [routerLinkActiveOptions]="{ exact: true }">
        <div class="admin-menu-image"></div>
        Manage system
      </mat-list-item>
      <mat-list-item *ngIf="adminRole | isInRole" class="license" [routerLink]="['/Admin/License']" [routerLinkActive]="'nav-active'"
        [routerLinkActiveOptions]="{ exact: true }">
        <div class="admin-menu-image"></div>
        License
      </mat-list-item>
      <mat-list-item *ngIf="adminRole | isInRole" class="backup" [class.disabled]="isAdminTabDisabled" (click)="onMenuClick()"
        [routerLink]="['/Admin/Backup']" [routerLinkActive]="'nav-active'" [routerLinkActiveOptions]="{ exact: true }">
        <div class="admin-menu-image"></div>
        Backup and Restore
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item
        class="wall"
        [routerLink]="['/Admin/Displays-Configuration-Tool']"
        [routerLinkActive]="'nav-active'"
        *ngIf="isAllowedByLicense() && adminRole | isInRole"
      >
        <div class="admin-menu-image"></div>
        Display config tool
      </mat-list-item>
      <mat-divider></mat-divider>
    </mat-nav-list>
  </mat-drawer>

  <div class="admin-content-layout" id="content">
    <div class="content">
      <button class="menu-trigger d-block d-md-none" mat-raised-button (click)="drawer.toggle()"><mat-icon svgIcon="menu"></mat-icon></button>
      <router-outlet></router-outlet>
    </div>
  </div>
</mat-drawer-container>

<div class="grayed-background" *ngIf="isToShowGrayedBg">
  <div class="grayed-background-top d-none d-md-block"></div>
</div>
